import { Injectable, OnDestroy, OnInit } from '@angular/core';
import { Router,ActivatedRoute } from '@angular/router';
import {Location} from '@angular/common';
import { AppInjector } from '../services/app-injector.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import {BaseService} from './services/base.service';
import { RegisterService } from '../services/users/register.service';
import { LogsService } from '../services/adminlogs/logs.service';
import { ConfirmationDialogService } from 'src/app/_utils/confirmation-dialog/confirmation-dialog.service';
import { ViewImageService } from '../_utils/view-image/view-image.service';
import { WorkingCompanyService } from '../services/working-company/working-company.service';
export enum Permission {
  Read="13",
  Write = "14",
  Edit = "15",
  Delete = "16",
  ViewAll="17",
  ModifyAll="18",
  Import="26",
  Export="27"
}

@Injectable()
export abstract class BaseComponent implements OnInit, OnDestroy {
  protected router: Router;
  protected location: Location;  
  protected ngxSpinnerService: NgxSpinnerService;
  protected toastrService:ToastrService;
  protected baseService:BaseService;
  protected activatedRoute: ActivatedRoute;
  protected registerService:RegisterService;
  protected logs :LogsService;
  protected confirmationDialogService:ConfirmationDialogService;
  protected viewImageService: ViewImageService;
  protected workingCompanyService: WorkingCompanyService;
  public isRead=false;
  public isWrite=false;
  public isEdit =false;
  public isDelete =false;
  public isViewAll=false;
  public isModifyAll=false;
  public isImport=false;
  public isExport=false;
  private wcWatchSub: any;
  private wcFieldName = 'companyID';
  private wcGetList: () => any[];
  private wcLoadFn: (id: string) => void;
  constructor() {
    const injector = AppInjector.getInjector();
    this.router = injector.get(Router);
    this.location = injector.get(Location);
    this.ngxSpinnerService = injector.get(NgxSpinnerService);
    this.toastrService=injector.get(ToastrService);
    this.baseService=injector.get(BaseService);
    this.activatedRoute=injector.get(ActivatedRoute);
    this.registerService=injector.get(RegisterService);
    this.logs=injector.get(LogsService); 
    this.confirmationDialogService=injector.get(ConfirmationDialogService); 
    this.viewImageService = injector.get(ViewImageService);
    this.workingCompanyService = injector.get(WorkingCompanyService);
    // console.log(Permission);
    // console.log(this.registerService.CurrentPagePermissions.value);  
    // console.log(this.registerService.CurrentPagePermissions.value.indexOf(Permission.Read+','));
    if(this.registerService.CurrentPagePermissions.value)
{
  var CurrentPagePermissions=this.registerService.CurrentPagePermissions.value.split(',');
  if(CurrentPagePermissions.indexOf(Permission.Delete)>=0)
  {
    this.isDelete=true;
  }
  if(CurrentPagePermissions.indexOf(Permission.Edit)>=0)
  {
    this.isEdit=true;
  }
  if(CurrentPagePermissions.indexOf(Permission.Read)>=0)
  {
    this.isRead=true;
  }
  if(CurrentPagePermissions.indexOf(Permission.Write)>=0)
  {
    this.isWrite=true;
  }
  if(CurrentPagePermissions.indexOf(Permission.Import)>=0)
  {
    this.isImport=true;
  }
  if(CurrentPagePermissions.indexOf(Permission.Export)>=0)
  {
    this.isExport=true;
  }
  if(CurrentPagePermissions.indexOf(Permission.ModifyAll)>=0)
  {
    this.isModifyAll=true;
  }
  if(CurrentPagePermissions.indexOf(Permission.ViewAll)>=0)
  {
    this.isViewAll=true;
  }
  // console.log("isDelete  "+ this.isDelete);
  // console.log("isViewAll  "+this.isViewAll);
  // console.log("isEdit  "+this.isEdit);
  // console.log("isRead  "+ this.isRead);
  // console.log("isWrite  "+this.isWrite);
  // console.log("isModifyAll  "+this.isModifyAll);
  // console.log("isImport  "+this.isImport);
  // console.log("isExport  "+this.isExport);
} 
  }

  ngOnInit() {

  }

  ngOnDestroy() {
    if (this.wcWatchSub) {
      this.wcWatchSub.unsubscribe();
      this.wcWatchSub = null;
    }
  }

  getDefaultCompanyId(): string {
    try {
      const user = JSON.parse(sessionStorage.getItem('userData') || '{}');
      if (user && user.admin_customer_id != null && String(user.admin_customer_id) !== '0') {
        return String(user.admin_customer_id);
      }
    } catch (e) {}
    return this.workingCompanyService.getId();
  }

  bindWorkingCompany(companyList: any[]): string {
    return this.workingCompanyService.bindFromList(companyList);
  }

  hydrateWorkingCompany(host: any, loadFn?: (id: string) => void): string {
    return this.workingCompanyService.applyToHost(host, loadFn);
  }

  applyWorkingCompany(fieldName: string, companyList: any[], loadFn: (id: string) => void): string {
    const working = this.bindWorkingCompany(companyList || []);
    const current = this[fieldName];
    if (working) {
      if (String(current || '') !== String(working)) {
        loadFn(String(working));
      }
      return String(working);
    }
    if (current && String(current) !== '0') {
      loadFn('');
    }
    return '';
  }

  watchWorkingCompany(fieldName: string, getList: () => any[], loadFn: (id: string) => void) {
    this.wcFieldName = fieldName;
    this.wcGetList = getList;
    this.wcLoadFn = loadFn;
    this.applyWorkingCompany(fieldName, getList() || [], loadFn);
    if (!this.wcWatchSub) {
      this.wcWatchSub = this.workingCompanyService.companyChange$.subscribe(() => {
        if (this.wcLoadFn) {
          this.applyWorkingCompany(this.wcFieldName, (this.wcGetList && this.wcGetList()) || [], this.wcLoadFn);
        }
      });
    }
  }
}